import React from "react";
import StringInput from "../formElements/StringInput";
import {useParams} from "react-router-dom";
import DateInput from "../formElements/DateInput";
import BooleanInput from "../formElements/BooleanInput";
import InstrumentHistory from "../../listViews/InstrumentHistory";
import GenericForm from "./GenericForm";
import FreeTypeSelectInput from "../formElements/FreeTypeSelectInput";

function InstrumentForm(props) {
    const {id} = useParams();
    const [resetOwner, setResetOwner] = React.useState(false)

    function formContent(data, update, updateCustom) {

        function deleteHistory(index) {
            let newData = {...data}
            newData['Historia'].splice(index, 1)
            updateCustom(newData)
        }

        function getStateOptions() {
            let options = data.Stav_options
            if (options) {
                options = options.sort((a, b) => a.localeCompare(b))
            }
            return options ? ['', ...options] : []
        }

        function getOwnerOptions() {
            return data.Firma_Adresa_options.map((item) => item.company).filter((item => item !== undefined))
        }

        function updateLocation(event, index) {
            let selectedAddressId = null
            if (event.target.value !== "") {
                const customerAddresses = getCustomerAddresses(data.Historia[index]['Vlastnik'])
                const selectedAddress = customerAddresses.find((item) => formatAddress(item) === event.target.value)
                selectedAddressId = selectedAddress.id
            }
            update({target: {name: `Historia.${index}.Umiestnenie_Instalacie`, value: selectedAddressId}})
        }

        function get_place(index) {
            const customerAddresses = getCustomerAddresses(data.Historia[index]['Vlastnik'])
            if (customerAddresses.length === 0) {
                return ""
            }
            if (data.Historia[index]['Umiestnenie_Instalacie'] === null) {
                return ""
            }
            const selectedAddress = customerAddresses.find((item) => item.id === data.Historia[index]['Umiestnenie_Instalacie'])
            return formatAddress(selectedAddress)
        }

        function getLocationOptions(index) {
            const customerAddresses = getCustomerAddresses( data.Historia[index]['Vlastnik'])
            let newOptions = customerAddresses.map((item) => formatAddress(item))
            newOptions.unshift("")
            return newOptions
        }

        function getCustomerAddresses(customer) {
            const addresses = data.Firma_Adresa_options.find((item) => item.company === customer).addresses
            return addresses
        }

        function formatAddress(address) {
            return `${address.Nazov}; ${address.Mesto}; ${address.Ulica}; ${address.PSC}`
        }

        function updateOwner(event, index) {
            if (getOwnerOptions().includes(event.target.value)) {
                let newData = {...data}
                newData['Historia'][index]['Vlastnik'] = event.target.value
                newData['Historia'][index]['Umiestnenie_Instalacie'] = null
                updateCustom(newData)
            }
            else {
                setResetOwner(!resetOwner)
            }
        }

        function selectOwner(event) {
            if (getOwnerOptions().includes(event.target.value)) {
                let newData = {...data}
                newData['Historia'].push({
                    'Vlastnik': event.target.value,
                    'Umiestnenie_Instalacie': null,
                    'Datum': null
                })
                updateCustom(newData)
            }
        }

        function updateDate(event, index) {
            update({target: {name: `Historia.${index}.Datum`, value: event.target.value}})
        }

        function updateManufactureDate(event) {
            let newData = {...data}
            // make insuranceDate from event.target.value and add to it 2 years
            if (newData['Zaruka'] === null) {
                let guaranteeDate = new Date(event.target.value)
                guaranteeDate.setFullYear(guaranteeDate.getFullYear() + 2)
                newData['Zaruka'] = guaranteeDate.toISOString().split('T')[0]
            }
            newData['Datum_Vyroby'] = event.target.value
            updateCustom(newData)
        }

        function getProductOptions() {
            let options = data.Produkt_options
            if (options) {
                options = options.sort((a, b) => a.localeCompare(b))
            }
            return options ? ['', ...options] : []
        }

        function updateProduct(event) {
            let newData = {...data}
            newData['Produkt'] = event.target.value
            updateCustom(newData)
        }

        return <>
            <StringInput name={'SNR'} label={'SNR'} value={data.SNR} onChange={update}/>
            <FreeTypeSelectInput options={getProductOptions()} name={'Produkt'} label={'Produkt'} value={data.Produkt} onChange={updateProduct}/>
            <DateInput name={'Datum_Vyroby'} label={'Dátum Výroby'} value={data.Datum_Vyroby} onChange={updateManufactureDate}/>
            <DateInput name={'Zaruka'} label={'Záruka'} value={data.Zaruka} onChange={update}/>
            <StringInput name={'Poznamka'} label={'Poznámka'} value={data.Poznamka} onChange={update}/>
            <FreeTypeSelectInput options={getStateOptions()} name={'Stav'} label={'Stav'} value={data.Stav} onChange={update}/>
            <BooleanInput name={'Demo'} label={'Demo'} value={data.Demo} onChange={update}/>
            <label style={{marginBottom: "10px"}}>QR kód: {data.QR}</label>
            <div className="mb-3">
                {(data.SNR && id) ?
                    <InstrumentHistory
                        data={data}
                        delete={deleteHistory}
                        getOwnerOptions={getOwnerOptions}
                        get_place={get_place}
                        getLocationOptions={getLocationOptions}
                        updateOwner={updateOwner}
                        selectOwner={selectOwner}
                        resetOwner={resetOwner}
                        updateLocation={updateLocation}
                        updateDate={updateDate}
                    />:
                    <BooleanInput name={'Moja_Firma'} label={'Moja Firma'} value={data.Moja_Firma} onChange={update}/>}
            </div>
        </>
    }

    return (
        <GenericForm label="Prístroj"
                     labelNew="Pridať Prístroj"
                     baseUrl='/instrument/instruments/'
                     formContent={formContent}
                     reportType={"instrument"}
                     qrGeneration={true}
                     reloadDataAfterSave={true}
        />
    );
}

export default InstrumentForm;